import cn from 'classnames';

import AvatarCircle from '@components/general/AvatarCircle/AvatarCircle';

import coinSvg from '@assets/svg/coin.svg';
import crownSvg from '@assets/svg/crown.svg';
import coinAnaSvg from '@assets/svg/coin-ana.svg';
import coinDuelSvg from '@assets/svg/coin-duel.svg';

import { ICoinflipGame } from '@api/types/Coinflip';

export default function CoinflipSide({
    game,
    styles,
    side,
    gameFinished,
}: {
    game: ICoinflipGame;
    styles: { readonly [key: string]: string };
    side: 'heads' | 'tails';
    gameFinished: boolean;
}): JSX.Element {
    const coinSide: 'duel' | 'ana' = side === 'heads' ? 'duel' : 'ana';
    const animationEnded =
        Math.floor(Date.now() / 1000) - game.game_metadata.ended_at >= 5;

    return (
        <div
            className={cn(styles.side, styles[`side__${coinSide}`], {
                [styles.winner]:
                    game[`${side}_user`] && game.result == side && gameFinished,
                [styles.inactive]:
                    !game[`${side}_user`] ||
                    (animationEnded && game.result !== side && gameFinished),
            })}
        >
            {side === 'tails' && (
                <span className={styles.username}>
                    {game.game_metadata.status === 'finished' &&
                        game.result === 'tails' &&
                        gameFinished &&
                        animationEnded && (
                            <div
                                className={styles.stake}
                                style={{ marginRight: '10px' }}
                            >
                                <img src={coinSvg} alt="coin icon" />
                                <span className={styles.value}>
                                    {game.stake.toLocaleString('en-US')}
                                </span>
                            </div>
                        )}
                    {game[`${side}_user`]
                        ? game[`${side}_user`].username
                        : 'Waiting for a player'}
                </span>
            )}

            {side === 'heads' && (
                <div
                    className={cn(styles.coin, styles.duel, {
                        [styles.winner]:
                            game[`${side}_user`] && game.result === side,
                    })}
                >
                    <img src={coinDuelSvg} className={styles.icon} />
                </div>
            )}

            {side == 'tails' && (
                <AvatarCircle
                    username={game[`${side}_user`]?.username}
                    avatar_url={game[`${side}_user`]?.avatar_url}
                    side={side}
                    winner={game[`${side}_user`] && game.result === side}
                />
            )}

            <div className={styles.divider}></div>

            {side == 'heads' && (
                <AvatarCircle
                    username={game[`${side}_user`]?.username}
                    avatar_url={game[`${side}_user`]?.avatar_url}
                    side={side}
                    winner={game[`${side}_user`] && game.result === side}
                />
            )}

            {side === 'tails' && (
                <div
                    className={cn(styles.coin, styles.ana, {
                        [styles.winner]:
                            game[`${side}_user`] && game.result === side,
                    })}
                >
                    <img src={coinAnaSvg} className={styles.icon} />
                </div>
            )}

            <div className={styles.sideWin}>
                <img src={crownSvg} className={styles.crown} />
                <div className={styles.stake}>
                    <img src={coinSvg} alt="coin icon" />
                    <span className={styles.value}>
                        {game.stake.toLocaleString('en-US')}
                    </span>
                </div>
            </div>

            {side === 'heads' && (
                <span className={styles.username}>
                    {game[`${side}_user`]
                        ? game[`${side}_user`].username
                        : 'Waiting for a player'}
                    {animationEnded && game.result === 'heads' && gameFinished && (
                        <div
                            className={styles.stake}
                            style={{ marginLeft: '10px' }}
                        >
                            <img src={coinSvg} alt="coin icon" />
                            <span className={styles.value}>
                                {game.stake.toLocaleString('en-US')}
                            </span>
                        </div>
                    )}
                </span>
            )}
        </div>
    );
}
